import { SecondaryButton } from '@designsforhealth/dfh-react-components'
import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const StyledGrid = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  padding: 10px;
`

export const Button = styled(SecondaryButton)`
  width: 100%;
  height: 140px;
  max-height: 140px;
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-radius: 8px;
  border: 2px solid transparent;
  &.selected {
    border-color: ${({ theme }) => theme.colors.brand.orange};
  }
  &:hover(not:disabled) {
    border-color: ${({ theme }) => theme.colors.coolGray.cool550};
    &.selected {
      border-color: ${({ theme }) => theme.colors.brand.orange};
    }
  }
`

export const Image = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
`

export const IconContainer = styled.div`
  height: 132px;
  margin-top: -132px;
  width: 100%-8px;
  margin-left: 8px;
  color: transparent;
  &.selected {
    color: ${({ theme }) => theme.colors.brand.orange};
  }
`
